import { WindowNames } from "@/resources/constants";
import { setShowWindow } from "@/redux/profile/authAndReg/slice";
import { openModal } from "react-url-modal";
import { Dispatch } from "@reduxjs/toolkit";

export const openAuthModal = (dispatch: Dispatch) => {
  dispatch(setShowWindow(WindowNames.AUTH));
  openModal({ name: "login", params: { showWindow: WindowNames.AUTH } });
};